import { Injectable } from '@angular/core';
import { BehaviorSubject, catchError, throwError } from 'rxjs';
import { ApiServiceService } from '../../../services/api-service.service';
import { environment } from '../../../../environments/environment';
import { formatParams } from '../../../helpers/FormateArrayToParams';
import * as XLSX from 'xlsx';
import * as FileSaver from 'file-saver';
// import { saveAs } from 'file-saver';

const EXCEL_EXTENSION = '.xlsx';
@Injectable({
    providedIn: 'root'
})
export class EmployeeService {

    refreshList = new BehaviorSubject<boolean>(false);

    constructor(private apiService: ApiServiceService) { }


    getEmployeeList(model: any): any {
        let Params = formatParams(model)
        return this.apiService.get(`${environment.apiUrl}/employees${Params}`)
            .pipe(catchError(this.handleError));
    }

    AddNewEmployee(employee: any) {
        return this.apiService.post(`${environment.apiUrl}/employees`, employee)
            .pipe(catchError(this.handleError));
    }

    UpdateEmployee(employee: any, id: string) {
        return this.apiService.post(`${environment.apiUrl}/employees/update-employee-profile/${id}`, employee)
            .pipe(catchError(this.handleError));
    }


    getEmployeeProfile(user_id: any) {
        return this.apiService.get(`${environment.apiUrl}/employees/profile?employee_id=${user_id}`)
            .pipe(catchError(this.handleError));
    }

    getEmployeeRedeemedOffers(filterModel: any) {
        return this.apiService.get(`${environment.apiUrl}/employee-redeemed-offers`, filterModel)
            .pipe(catchError(this.handleError));
    }

    getEmployeeWithdrawPoints(filterModel: any) {
        return this.apiService.get(`${environment.apiUrl}/employee-withdraw-points`, filterModel)
            .pipe(catchError(this.handleError));
    }


    GetTemplateFile(model: any) {
        return this.apiService.getDownload(`${environment.apiUrl}/employees/excel/generate_file_compnay`, model)
            .pipe(catchError(this.handleError));
    }


    CheckUploadedFile(data: any) {
        return this.apiService.post(`${environment.apiUrl}/employees/excel/check_user_import`, data)
            .pipe(catchError(this.handleError));
    }

    deleteEmployee(id: any) {
        return this.apiService.remove(`${environment.apiUrl}/user-management/users/delete-employee/${id}`)
            .pipe(catchError(this.handleError));
    }

    suspendUnSuspendEmployee(id: any, type: any) {
        // Type = suspend unsuspend
        return this.apiService.post(`${environment.apiUrl}/user-management/users/${type}-employee/${id}`)
            .pipe(catchError(this.handleError));
    }

    resendVerificationMailEmployee(id: any) {
        return this.apiService.post(`${environment.apiUrl}/resend-verification-employee/${id}`)
            .pipe(catchError(this.handleError));
    }

    ConfirmImport(data: any) {
        return this.apiService.post(`${environment.apiUrl}/employees/excel/confirm_user`, data)
            .pipe(catchError(this.handleError));
    }

    ExportEmployees(model: any) {
        return this.apiService.getDownload(`${environment.apiUrl}/employees/export/excel`, model)
            .pipe(catchError(this.handleError));
    }

    PrintPDF_Employees(model: any) {
        return this.apiService.getDownload(`${environment.apiUrl}/employees/export/pdf`, model)
            .pipe(catchError(this.handleError));
    }

    handleError(error: any) {
        return throwError(error);
    }

    saveAsExcelFile(buffer: any, fileName: string): void {
        const data: Blob = new Blob([buffer]);
        FileSaver.saveAs(data, fileName);
    }
}